import timePeriodList from "./time-period";
import countriesList from "./countries";

export default [...timePeriodList, ...countriesList];
